<template>
  <section class="section cms-assistance">
    <b-container>
      <div class="cms-assistance__head">
        <h5
          v-if="title"
          class="vb-heading h5 cms-assistance__title"
          v-html="title"
        ></h5>
        <div v-if="text" class="cms-assistance__subtitle" v-html="text"></div>
      </div>

      <b-row class="justify-content-center">
        <div
          v-for="(column, column_index) in resolved_columns"
          :key="`cms-assistance-${column_index}`"
          class="cms-assistance__col"
        >
          <content-link
            v-if="column.resolved_link"
            :link="column.resolved_link"
            class="cms-assistance__card cms-assistance__card--link"
          >
            <feature-card
              :icon="column.icon"
              :icon_background_color="sass('gray-200')"
              radius
              centered
              :title="column.title"
              :text="column.resolved_link.label"
            />
          </content-link>
          <div v-else class="cms-assistance__card">
            <feature-card
              :icon="column.icon"
              :icon_background_color="sass('gray-200')"
              radius
              centered
              :title="column.title"
            />
          </div>
        </div>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  /**
   * CMS `assistance` block: heading + grid of assistance channels.
   * Schema (props): `{ title, text, columns: [{ icon, title, link }] }`.
   * The whole card is clickable when the link is present; the link label is
   * rendered as the card description, as in the original component
   * (blocks/prefooter.vue, support flow).
   */
  import { resolve_link } from './content-utilities';
  import ContentLink from './content-link.vue';
  import FeatureCard from './feature-card.vue';

  export default {
    name: 'assistance',

    components: {
      'content-link': ContentLink,
      'feature-card': FeatureCard,
    },

    props: {
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      columns: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      resolved_columns() {
        return (this.columns || []).map((column) => ({
          ...column,
          resolved_link: resolve_link(column.link),
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cms-assistance {
    &__head {
      text-align: center;
      margin-bottom: $grid-gutter-width / 2;
    }

    &__col {
      flex: 0 1 295px + $grid-gutter-20;
      padding: ($grid-gutter-20 / 2);
    }

    &__card {
      display: block;
      height: 100%;
      color: inherit;
      text-decoration: none;
      border-radius: $border-radius-lg * 2;
      transition: box-shadow 0.2s ease;

      &--link:hover,
      &--link:focus {
        color: inherit;
        box-shadow: $box-shadow-sm;
      }

      ::v-deep .feature-card__icon {
        margin-bottom: $grid-gutter-width / 4;

        svg {
          width: 20px;
          height: 20px;
        }
      }

      ::v-deep .feature-card__text {
        max-width: 220px;
        line-height: 1.15;
      }
    }
  }
</style>
